import { ObjectMapper } from "json-object-mapper";
import { InsightSummaryItemModel } from "./insightSummaryItem.model";

export class InsightSummaryModel {
  cards: InsightSummaryItemModel[] = [];

  static create(input: any): InsightSummaryModel {
    return ObjectMapper.deserialize<InsightSummaryModel>(InsightSummaryModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}